import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { BiDollar, BiX } from 'react-icons/bi';

const TaxDeductionModal = () => {
  const { employees } = useSelector(state => state.employerEmployee);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Calculate total tax deduction and per employee tax
  const calculateTotalTax = () => {
    return employees.reduce((total, employee) => {
      const latestSalary = employee.salary?.history[employee.salary?.history.length - 1] || {};
      return total + (latestSalary.deductions?.tax || 0);
    }, 0);
  };

  const calculateEmployeeTaxes = () => {
    return employees.map(employee => {
      const latestSalary = employee.salary?.history[employee.salary?.history.length - 1] || {};
      return {
        name: `${employee.firstName} ${employee.lastName}`,
        TIN: `${employee.TIN}`,
        TINType: `${employee.TINType}`,
        tax: latestSalary.deductions?.tax || 0,
      };
    });
  };

  const totalTax = calculateTotalTax();
  const employeeTaxes = calculateEmployeeTaxes();

  return (
    <div className="p-6">
      <button
        onClick={() => setIsModalOpen(true)}
        className="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700 transition-colors flex items-center gap-2"
      >
        <BiDollar /> View Tax Deductions
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Tax Deduction Summary</h3>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <BiX size={24} />
              </button>
            </div>
            <div className="mb-4">
              <h4 className="text-lg font-semibold">Total Tax Deducted: N{totalTax.toFixed(2)}</h4>
            </div>
            <table className="w-full text-sm md:text-base">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 text-left">Employee Name</th>
                  <th className="py-2 px-4 text-left">Tax Deducted (N)</th>
                  <th className="py-2 px-4 text-left">Tax ID num </th>
                  <th className="py-2 px-4 text-left">Tax type </th>
                </tr>
              </thead>
              <tbody>
                {employeeTaxes.map((tax, index) => (
                  <tr key={index} className="border-t">
                    <td className="py-2 px-4">{tax.name}</td>
                    <td className="py-2 px-4">{tax.tax.toFixed(2)}</td>
                       <td className="py-2 px-4">{tax.TIN}</td>
                       <td className="py-2 px-4">{tax.TINType || 'TIN'} </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default TaxDeductionModal;